import { isBrowser } from "../../../common/helpers/env";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { hideNotification } from "../../store/notification/actions";
import isSupportedBrowser from "../../utils/isSupportedBrowser";
import { IStateTree } from "../../store/interfaces";

import { saveStoreValue, getStoreValue } from "./store";
import { StyledNotifications, Wrapper, StyledNotification, Close, NotificationButton } from "./styles";
import messages from "./messages";
import { IUser } from "../../store/user/models";
import { useNavigate, useLocation } from "react-router-dom";

const getMessageType = (message: string) => {
    if (message.indexOf("status code 401") !== -1) {
        return "401";
    }
    return "normal";
};

const Notifications = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [warningMessage, setWarningMessage] = useState<
        "expired" |
        "unauthorized" |
        "reload" |
        "browserversion" |
        "osversion" |
        "browser"
        | null
    >(null);
    const notifications = useSelector((state: IStateTree) => state.notifications);
    const user = useSelector((state: IStateTree) => state.user as IUser);

    useEffect(() => {
        const { supportMessage, isSupported } = isSupportedBrowser();
        const isNativeApp = location.search.includes("nativeApp=1");;
        if (!isNativeApp && isSupported === "warn" && getStoreValue()! < new Date().getTime() - 1000 * 60 * 60 * 24 * 2) {
            saveStoreValue(new Date().getTime());
            setWarningMessage(supportMessage);
        }
    }, []);

    if (notifications.length === 0 && !warningMessage) return null;
    if (!isBrowser || !document.getElementById) return null;
    return ReactDOM.createPortal(
        <StyledNotifications>
            <Wrapper>
                {warningMessage && (
                    <StyledNotification severity="warning">
                        <FormattedMessage {...messages[warningMessage]} />
                        <Close onClick={() => setWarningMessage(null)}>×</Close>
                    </StyledNotification>
                )}
                {notifications.map((notification, index) => {
                    const type = getMessageType(notification.message);
                    return (
                        <StyledNotification key={index} severity={notification.severity === "reload" || notification.severity === "hint" ? "warning" : ""}>
                            {type === "401" ? (
                                user.state === "loggedIn" ? (
                                    <FormattedMessage {...messages.expired} />
                                ) : (
                                    <FormattedMessage {...messages.unauthorized} />
                                )
                            ) : (
                                notification.message
                            )}
                            {((type === "401" && user.state === "loggedIn") || notification.severity === "reload") && (
                                <NotificationButton onClick={() => window.location.reload()}>
                                    <FormattedMessage {...messages.reload} />
                                </NotificationButton>
                            )}
                            <Close onClick={() => {
                                dispatch(hideNotification(index));
                            }}>×</Close>
                        </StyledNotification>
                    );
                })}
            </Wrapper>
        </StyledNotifications>,
        document.getElementById("notification-root")!
    );
}

export default Notifications;
